/**
 *
 * UserListItem
 *
 */

import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// antd component
import { List } from 'antd';

// icons
import CustomIcons from 'components/CustomIcons';

function UserListItem({
  element,
  searchString,
  // formats
  timeFormat,
  dateFormat,
  // func
  customHighlighter,
  // default props
  className,
  ...rest
}) {
  const childClassNames = classNames('user-list-meta', className);

  const userRole = element?.role == 'teacher' ? 'Enseignant' : element?.role;
  const userName = `${element?.description?.lastname} ${element?.description?.firstname}`;
  
  return element && (
    <List.Item.Meta
    className={childClassNames}
      title={customHighlighter(userName, searchString)}
      description={
        <>
          <span className="user-role">
            <CustomIcons type="person" />
            {customHighlighter(userRole, searchString)}
          </span>
        </>
      }
    />
  );

};

UserListItem.defaultProps = {
  dateFormat: 'DD.MM.YYYY',
  timeFormat: 'HH:mm',
};
UserListItem.propTypes = {
  element: PropTypes.oneOfType([
    PropTypes.object.isRequired,
    PropTypes.bool.isRequired,
  ]),
  searchString: PropTypes.string,
  customHighlighter: PropTypes.func.isRequired,
};

export default memo(UserListItem);